const STORAGE_KEY = 'strl-notification-bar-dismissed';

/**
 * Adjust sticky header CSS vars so main / sticky elements clear the bar.
 *
 * @param {number} barHeight
 */
function updateHeaderOffset(barHeight) {
	const root = document.documentElement;

	if (!root.dataset.headerHeightBase) {
		root.dataset.headerHeightBase = getComputedStyle(root).getPropertyValue('--strl-header-height').trim();
		root.dataset.mHeaderHeightBase = getComputedStyle(root).getPropertyValue('--strl-m-header-height').trim();
	}

	const desktop = parseFloat(root.dataset.headerHeightBase) || 0;
	const mobile = parseFloat(root.dataset.mHeaderHeightBase) || 0;

	root.style.setProperty('--strl-header-height', `${desktop + barHeight}px`);
	root.style.setProperty('--strl-m-header-height', `${mobile + barHeight}px`);
}

/**
 * Init notification bar dismiss + header offset.
 */
export default function notificationBar() {
	const bar = document.querySelector('[data-notification-bar]');
	if (!bar) {
		return;
	}

	const dismissId = bar.dataset.notificationId || '1';
	const alreadyDismissed = document.documentElement.classList.contains('notification-bar-dismissed');
	let dismissed = alreadyDismissed;

	if (!dismissed) {
		try {
			dismissed = localStorage.getItem(STORAGE_KEY) === dismissId;
		} catch (e) {
			dismissed = false;
		}
	}

	if (dismissed) {
		document.documentElement.classList.add('notification-bar-dismissed');
		bar.remove();
		updateHeaderOffset(0);
		return;
	}

	updateHeaderOffset(bar.offsetHeight);

	const closeButton = bar.querySelector('[data-notification-bar-close]');
	if (!closeButton) {
		return;
	}

	closeButton.addEventListener('click', () => {
		try {
			localStorage.setItem(STORAGE_KEY, dismissId);
		} catch (e) {
			// Ignore quota / private mode errors.
		}

		document.documentElement.classList.add('notification-bar-dismissed');
		updateHeaderOffset(0);
		bar.remove();
	});
}
